import { STRAINS } from "@/lib/strainsData";

export default function StrainPairSelectors({ ids, onChange, language }) {
  const pl = language === "pl";
  const options = [...STRAINS].sort((a, b) => a.name.localeCompare(b.name, language));
  return (
    <div className="grid grid-cols-2 gap-3 mb-4">
      {[0, 1].map((index) => (
        <div key={index} className="min-w-0 rounded-xl border border-border bg-card p-3 sm:p-4">
          <label htmlFor={`compare-strain-${index}`} className="block text-sm font-semibold mb-2">
            {pl ? `Odmiana ${index + 1}` : `Strain ${index + 1}`}
          </label>
          <select
            id={`compare-strain-${index}`}
            value={ids[index] || ""}
            disabled={index === 1 && !ids[0]}
            onChange={(event) => { const next = [...ids]; next[index] = event.target.value; onChange(next); }}
            className="w-full min-h-[44px] rounded-lg border border-input bg-background text-foreground px-2 text-sm disabled:opacity-50"
          >
            <option value="" disabled>{pl ? "Wybierz odmianę" : "Select a strain"}</option>
            {options.filter((s) => s.id !== ids[1 - index]).map((s) => (
              <option key={s.id} value={s.id}>{s.name} — {s.producer} · THC {s.thc}%</option>
            ))}
          </select>
        </div>
      ))}
    </div>
  );
}